/**
 * For use with dispatchCustomEvent().
 *
 * * This object only defines the events campaign page blocks utilizes.
 * * In Whammy, there is a similar Event.ts file that combines these events with
 * * Whammy-specific events.
 */
export const EVENT = {
  CART_ADD_ITEM: 'cart.add-item',
  CART_OPEN_MODAL: 'cart.open-modal',
  CART_MODAL_CLOSED: 'cart.model-closed',
  ANALYTICS_TRACK_EVENT: 'analytics.track-event'
};